import { render, staticRenderFns } from "./SubLotteryApp.vue?vue&type=template&id=4fa92327&scoped=true&"
import script from "./SubLotteryApp.vue?vue&type=script&lang=js&"
export * from "./SubLotteryApp.vue?vue&type=script&lang=js&"
import style0 from "./SubLotteryApp.vue?vue&type=style&index=0&id=4fa92327&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa92327",
  null
  
)

export default component.exports